// Globals
import { useCallback, useEffect, useState } from 'react';

// Modules
import { ChatContainer } from '@/modules/Chat';
import { socialLinksConfig } from '@/modules/SocialLinks';
import { SocketContainer } from '@/modules/Socket';

// Components
import { ChatIcon, CloseIcon, WidgetIcon } from '@/icons';
import {
  StyledFloatButton,
  StyledChat,
  StyledChatButton,
  StyledContainer,
  StyledIcon,
  StyledLinksWrapper,
  StyledWidget,
  StyledWrapper
} from './WidgetContainerStyles';

// Helpers
import { EXTERNAL_CHAT_BUTTON_ROOT_SELECTOR, EXTERNAL_CHAT_BUTTON_SELECTOR } from '../../helpers/constants';
import { registerWidgetControllerMethod, unregisterWidgetControllerMethod } from '../../helpers/widgetController';

const WidgetContainer = () => {
  const [tooltipOpened, setToggle] = useState(false);
  const [chatOpened, setChatToggle] = useState(false);

  const handleToggleFloatButton = useCallback(() => setToggle((prev) => !prev), []);
  const handleToggleChat = useCallback(() => setChatToggle((prev) => !prev), []);

  useEffect(() => {
    const openLauncher = () => {
      setChatToggle(false);
      setToggle(true);
    };

    registerWidgetControllerMethod('openLauncher', openLauncher);
    return () => unregisterWidgetControllerMethod('openLauncher');
  }, []);

  useEffect(() => {
    const li = document.querySelectorAll(EXTERNAL_CHAT_BUTTON_ROOT_SELECTOR);
    const buttons = document.querySelectorAll(EXTERNAL_CHAT_BUTTON_SELECTOR);
    const handler = () => setChatToggle(true);

    li.forEach((item) => {
      item.classList.remove('hidden');
    });
    buttons.forEach((item) => {
      item.addEventListener('click', handler);
    });

    return () => {
      buttons.forEach((item) => {
        item.removeEventListener('click', handler);
      });
    };
  }, []);

  return (
    <StyledWidget>
      {chatOpened && (
        <StyledChat>
          <SocketContainer>
            <ChatContainer onClose={handleToggleChat} />
          </SocketContainer>
        </StyledChat>
      )}
      {!chatOpened && (
        <StyledContainer $closed={!tooltipOpened}>
          {!tooltipOpened && (
            <StyledFloatButton onClick={handleToggleFloatButton}>
              <ChatIcon />
            </StyledFloatButton>
          )}
          <StyledWrapper $closed={!tooltipOpened}>
            <StyledLinksWrapper $closed={!tooltipOpened}>
              {socialLinksConfig.map((link) => (
                <StyledIcon href={link.href} key={link.key} target={link.target} data-tooltip={link.title}>
                  {link.icon}
                </StyledIcon>
              ))}
              <StyledChatButton onClick={handleToggleChat} data-tooltip="Онлайн чат" id="chat-widget-button">
                <WidgetIcon />
              </StyledChatButton>
              {tooltipOpened && (
                <StyledChatButton onClick={handleToggleFloatButton}>
                  <CloseIcon />
                </StyledChatButton>
              )}
            </StyledLinksWrapper>
          </StyledWrapper>
        </StyledContainer>
      )}
    </StyledWidget>
  )
};

export default WidgetContainer;
